<template>
  <div class="payment-modal-overlay" @click="handleClose">
    <div class="payment-modal" @click.stop>
      <div class="modal-header">
        <h3>扫码支付</h3>
        <button class="close-btn" @click="$emit('close')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="order-info">
          <div class="order-title">{{ title }}</div>
          <div class="order-price">¥{{ price }}</div>
        </div>

        <p class="pay-hint">请使用支付宝扫描下方二维码，向商家支付 <strong>¥{{ price }}</strong></p>

        <div class="qr-container">
          <img
            :src="qrCodeUrl"
            alt="支付宝收款码"
            class="qr-image"
            @error="onQrError"
          />
          <div v-if="qrLoadError" class="qr-error">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
            <span>二维码加载失败</span>
          </div>
        </div>

        <p class="pay-tip">
          支付完成后，请联系客服或在个人中心查看余额。<br />
          金币/VIP 将在核实后到账。
        </p>
      </div>

      <div class="modal-footer">
        <button class="close-footer-btn" @click="$emit('close')">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentModal',
  props: {
    title: {
      type: String,
      required: true
    },
    price: {
      type: [Number, String],
      required: true
    },
    orderId: {
      type: String,
      default: () => `ORDER_${Date.now()}`
    }
  },
  data() {
    return {
      qrLoadError: false,
      qrCodeUrl: '/images/alipay_qrcode.png'
    };
  },
  methods: {
    onQrError() {
      this.qrLoadError = true;
    },
    handleClose() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.payment-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(12, 25, 41, 0.94);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.payment-modal {
  width: 420px;
  max-width: 90%;
  background: linear-gradient(180deg, #1a2f4a 0%, #0f1c2e 100%);
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 16px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.55);
  overflow: hidden;
  animation: modal-in 0.3s ease;
}

@keyframes modal-in {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text);
}

.close-btn {
  width: 28px; height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--text-faint);
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
}

.close-btn:hover {
  color: var(--text);
  background: rgba(255,255,255,0.06);
}

.close-btn svg {
  width: 16px; height: 16px;
}

.modal-body {
  padding: 24px 20px 20px;
}

/* 订单信息 */
.order-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 18px;
}

.order-title {
  font-size: 15px;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
}

.order-price {
  font-size: 22px;
  font-weight: bold;
  color: var(--brand);
  white-space: nowrap;
}

.pay-hint {
  text-align: center;
  font-size: 13px;
  color: var(--text-dim);
  margin: 0 0 16px 0;
}

/* 二维码 */
.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  margin: 0 auto 18px;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  box-sizing: content-box;
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
}

.qr-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--danger);
  font-size: 13px;
  width: 100%;
  height: 100%;
}

.qr-error svg {
  width: 32px; height: 32px;
}

.pay-tip {
  font-size: 12px;
  line-height: 1.7;
  color: var(--text-faint);
  text-align: center;
  margin: 0;
}

/* 底部关闭按钮 */
.modal-footer {
  padding: 0 20px 20px;
  text-align: center;
}

.close-footer-btn {
  width: 100%;
  padding: 11px;
  background: var(--surface-3);
  color: var(--text-dim);
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.close-footer-btn:hover {
  background: var(--brand-soft);
  border-color: var(--brand);
  color: var(--brand);
}

@media (max-width: 480px) {
  .payment-modal {
    width: 95vw;
  }

  .qr-container {
    width: 180px;
    height: 180px;
  }

  .order-title {
    max-width: 160px;
  }
}
</style>
